import { defineMessages } from "react-intl";

const messages = defineMessages({
  changePeriod: {
    id: "email.creation.sendModal.changePeriod",
    defaultMessage: "Change",
    description: "Change period button in the email queue modal.",
  },
  emailIsQueued: {
    id: "email.creation.sendModal.emailIsQueued",
    defaultMessage: "Your mail has been queued",
    description: "email creation modal - Email is queued",
  },
  emailIsSent: {
    id: "email.creation.sendModal.emailIsSent",
    defaultMessage: "Your mail is on its way",
    description: "email creation modal - Email is sent",
  },
  emailIsSentAboutEmails: {
    id: "email.creation.sendModal.emailIsSentAboutEmails",
    defaultMessage: "About Emails",
    description: "email creation modal - Email is sent - about emails",
  },
  emailIsSentDescription: {
    id: "email.creation.sendModal.emailIsSentDescription",
    defaultMessage:
      "Please check your email client to confirm deliverability. Allow up to one minute for every email that is being sent.",
    description: "email creation modal - Email is sent description",
  },
  outSideSchedule: {
    id: "email.creation.sendModal.outSideSchedule",
    defaultMessage:
      "Mail has been queued because it is outside the scheduled sending hours, which can be changed in <a>Email Settings</a>.",
    description: "Outside schedule message",
  },
  period: {
    id: "email.creation.sendModal.period",
    defaultMessage: "Sending between {startTime} - {endTime} {timezone}",
    description: "Period in the email queue modal.",
  },
  reachSendLimit: {
    id: "email.creation.sendModal.reachSendLimit",
    defaultMessage:
      "Because you’ve reached your sending limits, these emails have been added to the queue until they can be sent.",
    description: "Reached your sending limits",
  },
});

export default messages;
